/* eslint-disable react/prop-types */
import { Fragment, memo } from 'react';

import clsx from 'libs/clsx';
import Typography from 'components/Typography';

function ExamQuestionNumbers({
  currentQuestionIndex,
  questions,
  answers,
  onNumberButtonClick,
}) {
  return (
    <div className="absolute inset-0 h-full max-h-full overflow-y-auto">
      <div className="grid grid-cols-5 gap-3 pr-2">
        {/* List nomor dari pertanyaan */}
        {questions.map((question, index) => {
          const isAnswered = answers[index] !== ' ';
          const isCurrentQuestion = index === currentQuestionIndex;

          const isFirst = index === 0;
          const isSubjectMatterSameWithPrev =
            questions[index - 1]?.subjectMatter === question.subjectMatter;

          // Tombol nomor masing-masing pertanyaan.
          return (
            <Fragment key={index}>
              {/* Nama materi */}
              {isFirst && (
                <div className="col-span-5">{question.subjectMatter}</div>
              )}

              {/* Nama materi */}
              {!isFirst && !isSubjectMatterSameWithPrev && (
                <div className="col-span-5 pt-1">{question.subjectMatter}</div>
              )}

              {/* Number button */}
              <button
                type="button"
                onClick={() => onNumberButtonClick(index)}
                className={clsx(
                  'p-1 rounded-md border-2 text-center relative',
                  isAnswered &&
                    isCurrentQuestion &&
                    'bg-green-100 text-green-700 border-green-500',
                  isAnswered &&
                    !isCurrentQuestion &&
                    'bg-green-500 text-white border-green-500',
                  !isAnswered &&
                    isCurrentQuestion &&
                    'bg-white text-black border-green-400',
                  !isAnswered &&
                    !isCurrentQuestion &&
                    'bg-gray-100 text-gray-500 border-gray-100'
                )}
              >
                {/* Question number */}
                <Typography as="span" className="font-normal">
                  {index + 1}
                </Typography>

                {/* Number button's badge */}
                {['pil', 'mlt', 'cck'].includes(questions[index].type) &&
                  isAnswered && (
                    <span className="absolute -top-3 -right-2 bg-white text-gray-700 px-1 text-xs rounded-full border-2 border-gray-300 font-semibold">
                      {answers[index].replace(' ', '_')}
                    </span>
                  )}
              </button>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default memo(ExamQuestionNumbers);
